(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return-request-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      const form = section.querySelector('.return-request__form');
      if (!form || form.dataset.validationReady === 'true') return;

      form.dataset.validationReady = 'true';
      const requiredFields = [...form.querySelectorAll('input[required]')];
      const submitButton = form.querySelector('.return-request__submit');

      const updateField = (field, showError = false) => {
        const wrapper = field.closest('.return-request__field');
        if (!wrapper) return;
        wrapper.classList.toggle('is-invalid', showError && !field.validity.valid);
      };

      const updateButton = () => {
        submitButton.disabled = !form.checkValidity();
      };

      requiredFields.forEach((field) => {
        field.addEventListener('input', () => {
          updateField(field, field.dataset.touched === 'true');
          updateButton();
        });
        field.addEventListener('blur', () => {
          field.dataset.touched = 'true';
          updateField(field, true);
        });
      });

      form.addEventListener('submit', (event) => {
        if (form.checkValidity()) return;
        event.preventDefault();
        requiredFields.forEach((field) => updateField(field, true));
        requiredFields.find((field) => !field.validity.valid)?.focus();
        updateButton();
      });

      updateButton();
    };

    document.querySelectorAll('[data-return-request-section]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector?.('[data-return-request-section]');
      if (section) initialize(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
